export default {
    ['repair']: 'תיקון',
    ['new-wig']: 'פאות חדשות',
    none: 'ללא',
    full: 'שלימה',
    fall: 'סרט',
    'kipa-fall': 'כיפה פול',
    'hand-made': 'עבודת יד',
}
